/* @flow */

import React from 'react';
// $FlowIgnore
import './style.css';
import style from 'components/Upload/style';
import FileInputContainer from 'containers/FileInputContainer';
import FileDropzoneContainer from 'containers/FileDropzoneContainer';
import UploadFilesTable from 'components/Tables/UploadFilesTable';
import Button from 'components/UIKit/Button/Button';
import Icon from 'components/UIKit/Icon/Icon';
import Spinner from 'components/UIKit/Spinner/Spinner';
import TransactionsLink from 'components/Links/TransactionsLink';
import { Row, Column } from 'components/UIKit/Flex';

export default function UploadSteps(props: any) {
  return (
    <FileDropzoneContainer addFiles={ props.addFiles }
      style={{
        ...style.container,
        display: `block`,
        backgroundColor: `white`,
        border: `none`,
      }}>
      <Column
        className="submit-files-dropzone"
        style={{ ...style.container, ...style.uploadContainer }}
      >
        <Row
          style={{
            height: '100%',
            border: '.3rem dashed #c9dce0',
            backgroundColor: 'hsl(193, 64%, 94%)',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Column style={ style.dropzoneContent }>
            <Icon style={ style.icon }>file_upload</Icon>

            <Row
              className="submit-files-dropzone-header"
              style={{ fontSize: '1.6rem' }}
            >
              Upload files for validation
            </Row>

            <Row style={{ fontSize: '1.2rem', paddingTop: `0.5rem`, marginBottom: '1rem' }}>
              Drag and drop files here or choose file(s)
            </Row>

            <span className="mdl-button"
                 style={{
                   lineHeight: '1.4',
                   padding: '.5rem 1rem'
                 }}>
              <FileInputContainer customDataTestID="button-upload-choose-files" addFiles={ props.addFiles } ALLOWED_FILE_TYPES={props.ALLOWED_FILE_TYPES} />
              Choose File(s)
            </span>
          </Column>
        </Row>
      </Column>

      <Column style={{
        ...style.tableContainer,
        transform: `translateY(${ props.step > 0 ? 0 : -100 }%)`,
      }}>
        <UploadFilesTable handleDelete={ props.delete }>
         { props.files }
        </UploadFilesTable>
      </Column>

      <Column style={{
        ...style.messageContainer,
        transform: `translateY(${ props.step > 0 ? -243 : 100 }%)`,
      }}>
        <Row style={{ fontSize: `1.3em`, padding: `1rem` }}>
          Please review the files. If they are correct click 'Validate'.
        </Row>

        <Row style={{ ...style.flash,
          backgroundColor: `forestgreen`,
          transform: `translateY(${ props.allValid ? -7 : 100 }%)`,
          opacity: props.allValid ? 1 : 0,
        }}>
          Validation succeeded. You can submit your file(s) to GDC.
        </Row>

        <Row style={{ ...style.flash,
          backgroundColor: `#BB0E3D`,
          transform: `translateY(${ props.hasInvalid ? -7 : 100 }%)`,
          opacity: props.hasInvalid ? 1 : 0,
        }}>
          View reports on invalid files to fix errors and re-upload.
        </Row>

        <Row style={{ ...style.flash,
          backgroundColor: `#BB0E3D`,
          transform: `translateY(${ props.improperFiles.length ? 0 : 100 }%)`
        }}>
            {`Some files were removed because they are either empty or not one of: ${ props.ALLOWED_FILE_TYPES.map(x => x).join(', ')}`}
            <span style={{ marginLeft: `auto` }}>
              <span className="flash-btn" style={{
                ...style.flashBtn,
                marginRight: `0.75rem`,
                opacity: props.viewingImproperFiles ? 0 : 1,
                transition: `opacity 0.3s ease`,
                whiteSpace: 'nowrap'
              }} onClick={ () => props.toggleImproperFilesView(true) }>
                View Files
              </span>

              <span className="flash-btn" style={ style.flashBtn }
                onClick={ props.clearForbidden }>
                Dismiss
              </span>
            </span>

        </Row>
      </Column>

      <Row style={{ ...style.buttonRow,
        zIndex: 1000,
        transition: `transform 0.6s ease`,
        transform: `translateY(${ props.step > 0 ? -100 : 0 }%)`,
      }}>

      { !props.hasInvalid && props.step < 2 &&
        <Button
          customDataTestID="button-upload-validate"
          style={{ marginRight: '1rem' }}
          onClick={ props.validateAll }
          disabled={!props.files.length}
        >
          VALIDATE
        </Button> }

      { !props.hasInvalid && (props.files.length === 0 || !props.allValid) && props.step < 2 &&
        <div className="mdl-button" style={{fontWeight: 300}}>
          ADD MORE FILES
          <FileInputContainer customDataTestID="button-upload-add-more-files" addFiles={ props.addFiles } ALLOWED_FILE_TYPES={props.ALLOWED_FILE_TYPES} />
        </div> }

      { props.hasInvalid &&
        <Button style={{ marginRight: '1rem' }}>
          <FileInputContainer customDataTestID="button-upload-re-upload" addFiles={ props.addFiles } ALLOWED_FILE_TYPES={props.ALLOWED_FILE_TYPES} />
          RE-UPLOAD
        </Button> }

      { (props.allValid || props.step === 2) &&
        <Button onClick={ props.submitAll }>
          CONFIRM UPLOAD
        </Button> }
      </Row>

      <Column style={{
        ...style.dropzoneContent, ...style.success,
        transform: `translateY(${ props.txId ? 0 : 100 }%)`,
      }}>
        <Icon style={{ ...style.icon, color: `white`, opacity: props.txId ? 1 : 0 }}>check_circle</Icon>

        <Row style={{ color: `white`, fontSize: `1.5em` }}>
          Your data has been successfully uploaded to the project workspace.
        </Row>

        <Row style={{ color: `white`, fontSize: `1.3em`, marginTop: `1.5rem` }}>
          { `The Transaction ID is: ${props.txId}` }
        </Row>

        <TransactionsLink
          query={{ id: props.txId, did: props.txId }}
          style={{ marginTop: `1.5rem` }}
          className="mdl-button"
          onClick={ () => {
            props.getSideNavData();
            props.closeModal();
          }}
        >
          Click here to view the transaction
        </TransactionsLink>
      </Column>

      <Column style={{
        ...style.loadingOverlay,
        opacity: props.allPending || props.errorMessage ? 1 : 0,
      }}>
        { props.errorMessage
          ? <div className="mdl-shadow--2dp"
            style={{
              backgroundColor: `white`,
              padding: `2rem`,
            }}>
              <Row>The following error has occured:</Row>
              <Row style={{ marginTop: `0.5rem` }}>{ props.errorMessage }</Row>
              <Row style={ style.errorContainer }>
                <Button style={{
                  backgroundColor: '#BB0E3D',
                  color: '#FFFFFF',
                  borderColor: '#FFFFFF'
                }}
                  onClick={ () => props.setStep(0) }>
                  Go Back
                </Button>
              </Row>
            </div>
          : <Spinner /> }
      </Column>

      { props.step > 0 &&
      <div style={{
        position: `absolute`,
        top: `5rem`,
        width: `100%`,
        height: `calc(100% - 13rem)`,
        backgroundColor: `#BB0E3D`,
        color: `white`,
        padding: `2rem`,
        boxSizing: `border-box`,
        transform: `translateY(${props.viewingImproperFiles ? 0 : -100}%)`,
        transition: `transform 0.3s ease`,
      }}>
        <table style={{ width: `100%` }}>
          <thead style={{ borderBottom: `1px solid rgba(255, 255, 255, 0.5)` }}>
            <tr>
              <th style={{ textAlign: `left`, lineHeight: `2.5rem` }}>Filename</th>
              <th style={{ textAlign: `left`, lineHeight: `2.5rem` }}>Reason for removal</th>
            </tr>
          </thead>
          <tbody>
            { props.improperFiles.map(x => (
            <tr>
              <td style={{ textAlign: `left`, lineHeight: `1.75rem` }}>{ x.name }</td>
              <td style={{ textAlign: `left`, lineHeight: `1.75rem` }}>{ x.reason }</td>
            </tr>
            ))}
          </tbody>
        </table>
      </div> }
    </FileDropzoneContainer>
  );
}
